import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-neutral-900 text-white py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
          <p className="text-neutral-400 text-sm text-center md:text-left">
            © {new Date().getFullYear()} Rock Under Broen. Alle rettigheder forbeholdes.
          </p>
          <div className="flex items-center space-x-6 text-sm">
            <Link 
              to="/privacy-policy" 
              className="text-neutral-400 hover:text-white transition-colors"
            >
              Privatlivspolitik
            </Link>
            <a 
              href="mailto:info@rubcrew.dk" 
              className="text-neutral-400 hover:text-white transition-colors"
            >
              Kontakt
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;